import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Typography } from '@genial/design-tokens';
import { Box, Button, Pressable } from 'native-base';
import React from 'react';

import { PublicOfferApplicationProps } from '../..';

export interface PublicOfferDocumentsProps {
  offer: PublicOfferApplicationProps['offer'];
}

export const PublicOfferDocuments: React.FC<PublicOfferDocumentsProps> = ({ offer }) => {
  const [documentsOpen, setDocumentsOpen] = React.useState(false);

  const handleChangeDocumentsOpen = () => {
    setDocumentsOpen((state) => !state);
  };

  const handleOpenLink = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <Box bg={Color.background} px="inline.xxxs" borderRadius={BoxRadius.sm}>
      <Pressable w="full" py="stack.xxxs" onPress={handleChangeDocumentsOpen}>
        <HStack justifyContent="space-between" alignItems="center">
          <UI.Text variant="semibold">Documentos</UI.Text>
          <UI.Icon name={documentsOpen ? 'ChevronUp' : 'ChevronDown'} size="xs" />
        </HStack>
      </Pressable>
      {!!documentsOpen && (
        <VStack space="stack.xxxs" pb="stack.xxxs">
          {offer.documents.length === 0 && (
            <UI.Text variant="regular" fontSize="xs" color="brand.tertiary.principal">
              Nenhum documento encontrado para esse produto
            </UI.Text>
          )}
          {offer.documents.map((document, id) => (
            <Button
              key={`document-${id}`}
              onPress={() => handleOpenLink(document.fileUrl)}
              variant="textLink"
              p={0}
              isDisabled={!document.fileAvailable}
              _text={{
                textTransform: 'none',
                fontFamily: Typography['fontfamily.base.semibold'],
                fontSize: Typography['fontsize.xs'],
              }}
              justifyContent="start"
              leftIcon={
                <UI.Icon name="Download" size="xxxs" color={Color['brand.tertiary.principal']} />
              }>
              {document.fileName}
            </Button>
          ))}
        </VStack>
      )}
    </Box>
  );
};
